import { render, staticRenderFns } from "./MainLedgerPrintCurrent.vue?vue&type=template&id=163aaaa3&scoped=true"
import script from "./MainLedgerPrintCurrent.vue?vue&type=script&lang=js"
export * from "./MainLedgerPrintCurrent.vue?vue&type=script&lang=js"
import style0 from "./MainLedgerPrintCurrent.vue?vue&type=style&index=0&id=163aaaa3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163aaaa3",
  null
  
)

export default component.exports